import React, {
  createContext,
  useEffect,
  useState,
  ReactNode,
  useContext,
} from 'react';
import { Location, useLocation } from 'react-router-dom';

interface NavigationHistoryContextValue {
  current?: Location;
  previous?: Location;
}

const NavigationHistoryContext = createContext<
  NavigationHistoryContextValue | undefined
>(undefined);

interface NavigationHistoryProviderProps {
  children: ReactNode;
}

export const NavigationHistoryProvider: React.FC<
  NavigationHistoryProviderProps
> = ({ children }) => {
  const location = useLocation();
  const [history, setHistory] = useState<NavigationHistoryContextValue>();

  useEffect(() => {
    setHistory((currentHistory) => {
      if (currentHistory?.current?.pathname === location.pathname) {
        return { current: location, previous: currentHistory.previous };
      }
      return { current: location, previous: currentHistory?.current };
    });
  }, [location]);

  return (
    <NavigationHistoryContext.Provider value={history}>
      {children}
    </NavigationHistoryContext.Provider>
  );
};

export const useNavigationHistory = () => useContext(NavigationHistoryContext);
